module.exports = __webpack_public_path__ + "static/media/joanna.7f039273.jpg";